import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import SampelImg from '../img/sampel.jpeg';
import ContentLoader from "react-content-loader"

function WorkHistories() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const result = await api.getWorks()
        console.log("result", result)

        for (let i = 0; i < result.length; i++) {
          result[i].no = result.length - i
        }

        setData(result)
        setLoading(false)
      } catch (e) {
        console.error(e)
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const NewLoader = (props) => (
    <div className={"max-w-screen-md md:m-auto px-4 sm:px-0"}>
      <ContentLoader
        speed={2}
        width={'100%'}  

        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="0" y="0" rx="3" ry="3" width="50%" height="20" />
        <rect x="0" y="35" rx="3" ry="3" width="100%" height="15" />       
      </ContentLoader>
    </div>
  )

  return loading ? <NewLoader /> :
    <div className="flex flex-col-reverse divide-y divide-y-reverse divide-gray-400 max-w-screen-md md:m-auto px-4 sm:px-0">
      {data.map(item => (
        <div className={"mb-4"} key={item.doc_id}>

          <div className={"mb-4"}>
            <div className="w-full sm:w-auto font-bold text-lg sm:text-3xl mb-3">{item.no}. {item.name}</div>

            <div className={"mb-4"}>{item.company}, {item.timeline}</div>

          </div>

        </div>

      ))}
    </div>

}

export default WorkHistories;